import { computed, type Signal } from '@angular/core';
import type { QpxMetadataItem } from '../metadata';

export interface ItemsState {
    visibleItems: Signal<readonly QpxMetadataItem[]>;
    hiddenItems: Signal<readonly QpxMetadataItem[]>;
    hasHiddenItems: Signal<boolean>;
}

export function createItemsState(
    items: Signal<readonly QpxMetadataItem[]>,
    hiddenItemIds: Signal<readonly string[]>
): ItemsState {
    const hiddenIds = computed(
        () =>
            new Set([
                ...hiddenItemIds(),
                ...items()
                    .filter((item) => item.overflowOnly)
                    .map((item) => item.id),
            ])
    );

    const visibleItems = computed(() => {
        return items().filter((item) => !hiddenIds().has(item.id));
    });

    const hiddenItems = computed(() => {
        return items().filter((item) => hiddenIds().has(item.id));
    });

    const hasHiddenItems = computed(() => hiddenItems().length > 0);

    return {
        visibleItems,
        hiddenItems,
        hasHiddenItems,
    };
}
